export default __webpack_public_path__ + "static/media/logoLegalTechFactory.57fdd350.webp";